var $67d5b76c8e7450d9$exports = {};
$67d5b76c8e7450d9$exports = {
    "endTime": `\u{5E9}\u{5E2}\u{5EA} \u{5E1}\u{5D9}\u{5D5}\u{5DD}`,
    "startTime": `\u{5E9}\u{5E2}\u{5EA} \u{5D4}\u{5EA}\u{5D7}\u{5DC}\u{5D4}`,
    "time": `\u{5D6}\u{5DE}\u{5DF}`
};


export {$67d5b76c8e7450d9$exports as default};
//# sourceMappingURL=he-IL.module.js.map
